import AudienceType from '@peachjar/school-finder-api/dist/api/AudienceType';
// currently, all staff, even district-staff, are given the designation school-staff.

export const SCHOOL_FINDER_AUDIENCE_FILTER_DEFAULTS = {
  [AudienceType.Parents]: true,
  [AudienceType.Staff]: false,
};
